/* Component to display all the Callsheet data
 * Contains the LocationsPage, TalentPage, BgPage,
   SchedulePage, NotesPage, CrewCallsPage, AdvancedSchedPage, 
   WalkiesPage, HospitalPage (mobile only) 
   and ContactsPage (mobile only) Components.
 * Contains the ContactUs component which sends an email to all crew
   and relevent cast menbers with the Callsheet URL 
 * Contains the 2 functions set the Crew and Cast Personal Call Times
   import toast from "react-hot-toast"; 
   toast.success(`Callsheet Created`);
   */
import React, { useEffect, useState } from "react";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useHistory } from "react-router-dom";
import { Image } from "react-bootstrap";
import TopBox from "../../components/TopBox";
import {
  useCrewEmailsContext,
  useCrewInfoContext,
} from "../../contexts/BaseCallContext";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import { PostDropdown } from "../../components/PostDropdown";
import sceneblue2 from "../../assets/sceneblue2.png"
import TalentPage from "./callsheetSections/TalentPage";
import BgPage from "./callsheetSections/BgPage";
import SchedulePage from "./callsheetSchedule/SchedulePage";
import LocationsPage from "./callsheetSections/LocationsPage";
import NotesPage from "./callsheetSections/NotesPage";
import CrewCallsPage from "./callsheetSections/CrewCallsPage";
import AdvancedSchedPage from "./callsheetSchedule/AdvancedSchedPage";
import ContactsPage from "./callsheetSections/MobileViewContactsPage";
import WalkiesPage from "./callsheetSections/WalkiesPage";
import HospitalPage from "./callsheetSections/HospitalPage";
import { SendCallsheet } from "../../components/SendCallsheet";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";
import { useCurrentUser } from "../../contexts/CurrentUserContext";

import btnStyles from "../../styles/Button.module.css";
import styles from "../../styles/Callsheets.module.css";
import toast from "react-hot-toast";
import InfoCall from "./info/InfoCall";

const CallSheet = (props) => {
  // eslint-disable-next-line
  const host = useHostName();
  const cUser = useCurrentUser();
  const crewEmailList = useCrewEmailsContext();
  const crewEmailLength = Array.isArray(crewEmailList) ? crewEmailList.length : 0;
  const crewInfoOne = useCrewInfoContext();
  const history = useHistory();
  // const { id: routeDayId } = useParams();
  const [yourcalltime, setYourcalltime] = useState("");
  const [yourCastcalltime, setYourCastcalltime] = useState("");
  // eslint-disable-next-line
  const [yourCastUser, setYourCastUser] = useState("");
  const [showInfo, setShowInfo] = useState(false);
  const [showSend, setShowSend] = useState(false);
  const [showHos, setShowHos] = useState(false);
  const [showContacts, setShowContacts] = useState(false);
  const [showLoc, setShowLoc] = useState(false);
  const [showWalkies, setShowWalkies] = useState(false);
  const [showSched, setShowSched] = useState(false);
  const [showTalent, setShowTalent] = useState(false);
  const [showBg, setShowBg] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const [showCrew, setShowCrew] = useState(false);
  const [showAdvanSched, setShowAdvanSched] = useState(false);
  const queryString = window.location.search;

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  // const urlDayId = params.get("day_id");
  const epi = params.get("episode");
  const project = params.get("project");
  const episodeTitle = params.get("episodeTitle");

  const firstname = cUser?.first_name;
  const lastname = cUser?.last_name;
  const cName = cUser?.call_time_username;
  // const uName = cUser?.username;

  const {
    production_name,
    production_company,
    company_phone,
    company_email,
    company_address_line_1,
    company_address_line_2,
    company_address_line_3,
    company_address_line_4,
    company_logo,
    total_shoot_days,
    director_name,
    director_phone,
    producer_name,
    producer_phone,
    pro_coordinator_name,
    pro_coordinator_phone,
    // eslint-disable-next-line
    upm_name,
    // eslint-disable-next-line
    upm_phone,
    ad_1_name,
    ad_1_phone,
    // eslint-disable-next-line
    dop_name,
    // eslint-disable-next-line
    dop_phone,
    // eslint-disable-next-line
    set_medic_name,
    // eslint-disable-next-line
    set_medic_email,
    // eslint-disable-next-line
    set_medic_phone,
  } = crewInfoOne || {};

  const {
    scenes,
    // eslint-disable-next-line
    handleMount,
    // currentUser,
    cast,
    castEmails,
    callsheet,
    background,
    // info
    id,
    day,
    date,
    day_id,
    unit_call,
    talent_call,
    shoot_call,
    breakfast,
    lunch,
    wrap,
    // eslint-disable-next-line
    location_1_name,
    location_2_name,
    location_3_name,
    location_4_name,
    location_5_name,
    nearest_hospital,
    hospital_address_line_1,
    hospital_address_line_2,
    hospital_address_line_3,
    hospital_address_line_4,
    // eslint-disable-next-line
    weather_location,
    important_info,
    transport_info,
    department_info,
    // production
    director_calltime,
    producer_calltime,
    pro_coordinator_calltime,
    travel_coordinator_calltime,
    upm_calltime,
    production_pa_calltime,
    script_supervisor_calltime,
    legal_calltime,
    set_medic_calltime,
    oth_production_pos_1_calltime,
    oth_production_pos_2_calltime,
    oth_production_pos_3_calltime,
    oth_production_pos_4_calltime,
    oth_production_pos_5_calltime,
    // art
    production_designer_calltime,
    art_director_calltime,
    art_assistant_calltime,
    set_decorator_calltime,
    set_dresser_calltime,
    lead_man_calltime,
    dresser_calltime,
    prop_master_calltime,
    ass_prop_master_calltime,
    prop_buyer_calltime,
    // cam
    dop_calltime,
    camera_operator_calltime,
    camera_ass_1_calltime,
    camera_ass_2_calltime,
    dit_calltime,
    steadicam_calltime,
    camera_pa_calltime,
    oth_camera_pos_1_calltime,
    oth_camera_pos_2_calltime,
    oth_camera_pos_3_calltime,
    oth_camera_pos_4_calltime,
    oth_camera_pos_5_calltime,
    // casting
    casting_director_calltime,
    extras_casting_calltime,
    ad_1_calltime,
    ad_2_calltime,
    ad_3_calltime,
    ad_4_calltime,
    ad_5_calltime,
    pro_assistant_1_calltime,
    pro_assistant_2_calltime,
    pro_assistant_3_calltime,
    pro_assistant_4_calltime,
    pro_assistant_5_calltime,
    // ele/Grip
    gaffer_calltime,
    best_boy_electric_calltime,
    electric_3_calltime,
    electric_4_calltime,
    keygrip_calltime,
    best_boy_grip_calltime,
    dolly_grip_calltime,
    swing_ge1_calltime,
    swing_ge2_calltime,
    swing_ge3_calltime,
    swing_ge4_calltime,
    swing_ge5_calltime,
    // locations
    location_mngr_calltime,
    location_security_calltime,
    location_ass_1_calltime,
    location_ass_2_calltime,
    location_ass_3_calltime,
    location_ass_4_calltime,
    // makeup
    key_hairmakeup_calltime,
    key_hairstylist_calltime,
    sfx_makeup_calltime,
    sfx_makeup_assistant_calltime,
    makeup_artist_1_calltime,
    makeup_artist_2_calltime,
    makeup_artist_3_calltime,
    makeup_artist_4_calltime,
    makeup_artist_5_calltime,
    // post/add-pos
    editor_calltime,
    fx_calltime,
    add_pos_1_calltime,
    add_pos_2_calltime,
    add_pos_3_calltime,
    add_pos_4_calltime,
    add_pos_5_calltime,
    add_pos_6_calltime,
    add_pos_7_calltime,
    add_pos_8_calltime,
    add_pos_9_calltime,
    add_pos_10_calltime,
    // add pos 11-20
    add_pos_11_calltime,
    add_pos_12_calltime,
    add_pos_13_calltime,
    add_pos_14_calltime,
    add_pos_15_calltime,
    add_pos_16_calltime,
    add_pos_17_calltime,
    add_pos_18_calltime,
    add_pos_19_calltime,
    add_pos_20_calltime,
    // script/cater
    writer_calltime,
    catering_co_1_calltime,
    catering_co_2_calltime,
    catering_co_3_calltime,
    craft_service_calltime,
    crafty_ass_calltime,
    // sound/transport
    sound_mixer_calltime,
    boom_operator_calltime,
    sound_assistant_1_calltime,
    sound_assistant_2_calltime,
    transport_captain_calltime,
    transport_manager_1_calltime,
    transport_manager_2_calltime,
    head_driver_calltime,
    car1_calltime,
    car2_calltime,
    car3_calltime,
    truck1_calltime,
    truck2_calltime,
    truck3_calltime,
    // stunts
    stunt_coordinator_calltime,
    stunts_1_calltime,
    stunts_2_calltime,
    stunts_3_calltime,
    stunts_4_calltime,
    stunts_5_calltime,
    // wardrobe
    costume_designer_calltime,
    ass_costume_designer_calltime,
    wardrobe_assistant_1_calltime,
    wardrobe_assistant_2_calltime,
    wardrobe_assistant_3_calltime,
    wardrobe_assistant_4_calltime,
    wardrobe_assistant_5_calltime,
  } = props;

  // Single key used for both cast + crew personal calltime lookups
  // (prefer call_time_username, fall back to auth username / legacy prop).

  const castEmailLength = castEmails.length;

  // filter the scenes here to make new array where location address are not duplicated

  const newLocs = [];
  const seenLocationKeys = new Set();
  const norm = (v) => (typeof v === "string" ? v.trim().toLowerCase() : "");

  for (const scene of scenes.results) {
    // Prefer address; if empty, fall back to filming location
    const locationValue =
      scene.location_address?.trim() || scene.filming_location?.trim() || "";
    const locationKey = norm(locationValue);

    // If both are empty, don't collapse multiple blanks into one
    if (!locationKey) {
      newLocs.push(scene);
      continue;
    }

    if (seenLocationKeys.has(locationKey)) continue;
    seenLocationKeys.add(locationKey);
    newLocs.push(scene);
  }
  // newLocs = scenes.results.filter(
  //   (scene) => !newLocs.includes(scene.location_address)
  // );

  const firstLoc = scenes.results[0]?.filming_location || "";

  // Personal Call times
  // 1. User: need to get the currentuser's call_time_username 
  // this is in their Profile and needs available in currentuser
  // so it can be got by currentuser.call_time_username 
  // or as cUser is now being used for currentuser 
  // cUser.call_time_username in line 83 above

  // 2. Cast: Same as above for the user
  // this is being compared with the Cast object's username
  // which has been set to the call_time_username but it works and
  // is not causing errors so cast.username is correct and fetches the callname
  // the below function to work if the call_time_username is gotten from the currentUser
  // it will say:
  // (obj) => obj.username === cUser.call_time_username


  // 3. Crew: function here to compare the currentuser's call_time_username
  //  cUser.call_time_name with that with different cases

  // Cast Personal Call Times
  useEffect(() => {
    /* Function to set the Cast Personal Call Times in yourCall 
           By filtering the cast array and by the current user */
    const actorcalldata = cast.results.filter(
      (obj) => obj.username === cName
    );
    const actorcall = actorcalldata[0]?.call || "";
    const actorUsername = actorcalldata[0]?.username || "";
    setYourCastcalltime(actorcall);
    setYourCastUser(actorUsername);
  }, [cName, cast.results]);


  // Crew Personal Call Times
  useEffect(() => {
    /* Function to set the Crew Personal Call Times in yourCall 
           by using the crew currentuser calltime_name to return their
           corrisponding Call Time
           it is now using the currentuser name uName so change it to cName */
    const yourcall = (cName) => {
      switch (cName) {
        // production
        // director: replaced old test key (was "david2")
        case "director":
          return director_calltime;
        case "producer":
          return producer_calltime;
        case "procoord":
          return pro_coordinator_calltime;
        case "unitpm":
          return upm_calltime;
        case "travelco":
          return travel_coordinator_calltime;
        case "produpa":
          return production_pa_calltime;
        case "addpro1":
          return oth_production_pos_1_calltime;
        case "addpro2":
          return oth_production_pos_2_calltime;
        case "addpro3":
          return oth_production_pos_3_calltime;
        case "addpro4":
          return oth_production_pos_4_calltime;
        case "addpro5":
          return oth_production_pos_5_calltime;
        case "setmedic":
          return set_medic_calltime;
        // casting / assistant directors
        case "xtracas":
          return extras_casting_calltime;
        case "astdir1":
          return ad_1_calltime;
        case "astdir2":
          return ad_2_calltime;
        case "astdir3":
          return ad_3_calltime;
        case "astdir4":
          return ad_4_calltime;
        case "astdir5":
          return ad_5_calltime;
        case "proast1":
          return pro_assistant_1_calltime;
        case "proast2":
          return pro_assistant_2_calltime;
        case "proast3":
          return pro_assistant_3_calltime;
        // camera
        case "dophoto":
          return dop_calltime;
        case "camerop":
          return camera_operator_calltime;
        case "astcam1":
          return camera_ass_1_calltime;
        case "astcam2":
          return camera_ass_2_calltime;
        case "digitec":
          return dit_calltime;
        case "steadicam":
          return steadicam_calltime;
        case "camerapa":
          return camera_pa_calltime;
        case "addcam1":
          return oth_camera_pos_1_calltime;
        case "addcam2":
          return oth_camera_pos_2_calltime;
        case "addcam3":
          return oth_camera_pos_3_calltime;
        case "addcam4":
          return oth_camera_pos_4_calltime;
        // sound transport
        case "soundmix":
          return sound_mixer_calltime;
        case "boomop":
          return boom_operator_calltime;
        case "sound1":
          return sound_assistant_1_calltime;
        case "sound2":
          return sound_assistant_2_calltime;
        case "trancap":
          return transport_captain_calltime;
        case "transpo1":
          return transport_manager_1_calltime;
        case "transpo2":
          return transport_manager_2_calltime;
        case "headrive":
          return head_driver_calltime;
        case "carone":
          return car1_calltime;
        case "cartwo":
          return car2_calltime;
        case "carthree":
          return car3_calltime;
        // art 
        case "prodesign":
          return production_designer_calltime;
        case "artdirect":
          return art_director_calltime;
        case "artstand":
          return catering_co_1_calltime;
        case "decassist":
          return catering_co_2_calltime;
        case "swingga1":
          return catering_co_3_calltime;
        case "artassist":
          return art_assistant_calltime;
        case "setdecor":
          return set_decorator_calltime;
        case "setdress":
          return set_dresser_calltime;
        case "leadman":
          return lead_man_calltime;
        case "dresser":
          return dresser_calltime;
        case "propmast":
          return prop_master_calltime;
        case "propast":
          return ass_prop_master_calltime;
        case "onsetpro":
          return oth_camera_pos_5_calltime;
        case "propbuy":
          return sound_assistant_1_calltime;
        case "armorer":
          return prop_buyer_calltime;
        // elec / grip
        case "gaffer":
          return gaffer_calltime;
        case "bbelect":
          return best_boy_electric_calltime;
        case "elect3":
          return electric_3_calltime;
        case "elect4":
          return electric_4_calltime;
        case "keygrip":
          return keygrip_calltime;
        case "bbgrip":
          return best_boy_grip_calltime;
        case "dolgrip":
          return dolly_grip_calltime;
        case "swing1":
          return swing_ge1_calltime;
        case "swing2":
          return swing_ge2_calltime;
        case "swing3":
          return swing_ge3_calltime;
        case "swing4":
          return swing_ge4_calltime;
        case "swing5":
          return swing_ge5_calltime;
        // locations 
        case "locman":
          return location_mngr_calltime;
        case "locman2":
          return location_ass_1_calltime;
        case "locmanas":
          return location_ass_2_calltime;
        case "locast1":
          return location_ass_3_calltime;
        case "locast2":
          return location_ass_4_calltime;
        case "locsecur":
          return location_security_calltime;
        // wardrobe
        case "cosdesign":
          return costume_designer_calltime;
        case "cosdesast":
          return ass_costume_designer_calltime;
        case "warsuper":
          return casting_director_calltime;
        case "keycostu":
          return pro_assistant_4_calltime;
        case "truckcos":
          return pro_assistant_5_calltime;
        case "setcost1":
          return wardrobe_assistant_4_calltime;
        case "setcost2":
          return wardrobe_assistant_5_calltime;
        case "wardrobe1":
          return wardrobe_assistant_1_calltime;
        case "wardrobe2":
          return wardrobe_assistant_2_calltime;
        case "wardrobe3":
          return wardrobe_assistant_3_calltime;
        // makeup
        case "keymake":
          return key_hairmakeup_calltime;
        case "keyhair":
          return key_hairstylist_calltime;
        case "fxmake":
          return sfx_makeup_calltime;
        case "fxmakast":
          return sfx_makeup_assistant_calltime;
        case "makeup1":
          return makeup_artist_1_calltime;
        case "makeup2":
          return makeup_artist_2_calltime;
        case "makeup3":
          return makeup_artist_3_calltime;
        case "makeup4":
          return makeup_artist_4_calltime;
        // post / additional 
        case "editor":
          return editor_calltime;
        case "vfxsuper":
          return fx_calltime;
        case "addcrew1":
          return add_pos_1_calltime;
        case "addcrew2":
          return add_pos_2_calltime;
        case "addcrew3":
          return add_pos_3_calltime;
        case "addcrew4":
          return add_pos_4_calltime;
        case "addcrew5":
          return add_pos_5_calltime;
        case "addcrew6":
          return add_pos_6_calltime;
        case "addcrew7":
          return add_pos_7_calltime;
        case "addcrew8":
          return add_pos_8_calltime;
        case "addcrew9":
          return add_pos_9_calltime;
        case "addcrew10":
          return add_pos_10_calltime;
        // additional 11 - 15
        case "addcrew11":
          return add_pos_11_calltime;
        case "addcrew12":
          return add_pos_12_calltime;
        case "addcrew13":
          return add_pos_13_calltime;
        case "addcrew14":
          return add_pos_14_calltime;
        case "addcrew15":
          return add_pos_15_calltime;
        // script /catering
        case "scriptsup":
          return script_supervisor_calltime;
        case "writer":
          return writer_calltime;
        case "crafts":
          return craft_service_calltime;
        case "crafty":
          return crafty_ass_calltime;
        // stunt
        case "stuntco":
          return stunt_coordinator_calltime;
        case "stunts1":
          return stunts_1_calltime;
        case "stunts2":
          return stunts_2_calltime;
        case "sfxsuper":
          return stunts_3_calltime;
        case "sfxassis1":
          return stunts_4_calltime;
        case "sfxassis2":
          return stunts_5_calltime;
        // extra
        // con
        case "carpenby":
          return truck2_calltime;
        case "paintby":
          return add_pos_19_calltime;
        case "riggerby":
          return makeup_artist_5_calltime;
        case "stageby":
          return truck3_calltime;
        case "wrangler":
          return legal_calltime;
        case "truck1":
          return truck1_calltime;
        case "tecdir":
          return add_pos_16_calltime;
        case "floorman":
          return add_pos_17_calltime;
        case "audioa1":
          return add_pos_18_calltime;
        case "stageman":
          return add_pos_20_calltime;
        default:
          return "";
      }
    };
    setYourcalltime(yourcall(cName));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cName]);

  const handleEdit = () => {
    history.push(
      `/${localStorage.getItem("projectSlug")}/callsheet/edit/${day_id}/${epi && project && episodeTitle
        ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
        : ""
      }`
    );
  };

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`callsheetsnew/${id}/`);
        history.goBack();
        toast.success(`Callsheet Deleted`);
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/callsheetsnew/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        history.goBack();
        toast.success(`Callsheet Deleted Successfully!`);
      }
    } catch (err) { }
  };
  const handleReceived = async () => {
    const recipientId = callsheet?.active_email_recipient_id;

    if (!recipientId) {
      toast.error("No active recipient found for this callsheet.");
      return;
    }

    const payload = { recipient_id: recipientId };

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.post(`callsheetsnew/${id}/email-received/`, payload);
      } else {
        const response = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/callsheetsnew/${id}/email-received/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );

        if (response?.success === false) {
          throw response.error;
        }
      }

      toast.success("Recipient marked as received.");
      if (typeof handleMount === "function") {
        await handleMount();
      }
    } catch (err) {
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        "Failed to mark recipient as received.";
      toast.error(backendError);
    }
  };

  // Advanced Schedule day_id is stored in hospital_address_line_4
  // (when absent, Advanced Schedule is not shown).
  const advancedScheduleDayId = hospital_address_line_4;
  return (
    <div className={`${styles.White} px-3`}>
      <TopBox
        title={`Call Sheet`}
        title2={`Day ${day} -`}
        title3={date}
        episodeTitle={`Episode ${episodeTitle}`}
      />
      <Row className="py-0 my-1" >
        {/* back button */}
        <Col xs={3}>
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue}`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </Col>
        {/* RECEIVED button to go here*/}
        <Col xs={6} className="text-center px-0 mx-0">
          <Button
            className={`${btnStyles.Track} ${btnStyles.WideTrack} ${btnStyles.Button} ${styles.AcknowledgeButton}`}
            onClick={handleReceived}
            disabled={Boolean(callsheet?.user_acknowledge_email)}
          >
            {callsheet?.user_acknowledge_email ? "ACKNOWLEDGED" : "ACKNOWLEDGE"}
          </Button>
        </Col>
        {/* info button */}
        <Col xs={3}>
          <Button
            className={`float-right ${btnStyles.Order} ${btnStyles.Button}`}
            onClick={() => setShowInfo((showInfo) => !showInfo)}
          >
            INFO
          </Button>
        </Col>
      </Row>
      <Row className="py-0 my-3" >
        {/* SEND button */}
        <Col xs={2}></Col>
        <Col xs={4} className="text-center px-0 mx-0">
          {cUser &&
            cUser?.groups?.length > 0 &&
            (cUser?.groups[0]?.name === "Superadmin") && (
              <Button
                className={`${btnStyles.OrderS} ${btnStyles.Button}`}
                onClick={() => setShowSend((showSend) => !showSend)}
              >
                SEND EMAILS
              </Button>
            )}
        </Col>
        {/* RECEIVED PAGE button here */}
        <Col xs={4} className="text-center px-0 mx-0">
          {cUser &&
            cUser?.groups?.length > 0 &&
            (cUser?.groups[0]?.name === "Superadmin") && (
              <Button
                className={`${btnStyles.OrderS} ${btnStyles.Button}`}
                onClick={() =>
                  history.push(
                    `/${localStorage.getItem("projectSlug")}/callsheets/${id}/received${epi && project && episodeTitle
                      ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
                      : ""
                    }`
                  )
                }
              >RECEIVED PAGE
              </Button>
            )}
        </Col>
        {/* edit/detete button */}
        <Col className={`text-right px-0 mx-0 ${styles.Icon}`} xs={2}>
          {cUser &&
            cUser?.groups?.length > 0 &&
            (cUser?.groups[0]?.name === "Superadmin") && (
              <PostDropdown
                handleEdit={handleEdit}
                handleDelete={handleDelete}
              />
            )}
        </Col>
      </Row>
      {!showInfo ? "" : <InfoCall />}
      {!showSend ? (
        ""
      ) : (
        <SendCallsheet
          callsheetId={callsheet?.id}
          dayId={day_id}
          castEmailLength={castEmailLength}
          crewEmailLength={crewEmailLength}
          setShowSend={setShowSend}
          crewEmailList={crewEmailList}
          castEmails={castEmails}
          day1={day}
          date1={date}
        />
      )}
      {/* MEDIUM  */}
      <div className="d-none d-md-block mt-1">
        {location_5_name && (
          <Row>
            <Col
              className={`text-center `}
              md={{ span: 4, offset: 4 }}
            >
              <div className={`mx-3 pb-0 px-2 ${styles.CountryBack}`}>
                <h4 style={{ textTransform: 'uppercase' }} className={` ${styles.vv}`}>
                  {location_5_name} SHOOT</h4>
              </div>
            </Col>
          </Row>
        )}
        <Row className="px-3">
          <Col md={4}>
            <Row className="mb-1 mt-5">
              <Col xs={12}>
                <h5 className={`mb-1 pl-0 ${styles.WhiteAquaProU}`}>
                  {production_company}{" "}
                </h5>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  {company_address_line_1}{" "}
                </p>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  {company_address_line_2}{" "}
                </p>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  {company_address_line_3}{" "}
                </p>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  {company_address_line_4}{" "}
                </p>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  Phone {company_phone}{" "}
                </p>
                <p className={`mb-1 pl-0 ${styles.WhiteAquaPro}`}>
                  Email {company_email}{" "}
                </p>
              </Col>
            </Row>
            {/* Producer */}
            <Row className="mt-3">
              <Col xs={12} className="pr-0">
                <p className={`mb-1`}>
                  <span className={`${styles.BoldU}`}>Producer:</span>{" "}
                </p>
              </Col>
              <Col xs={12} className="pr-0">
                <p className={`${styles.WhiteAqua} mb-1`}>
                  {producer_name} - {producer_phone}{" "}
                </p>
              </Col>
            </Row>
            {/* pro-cor */}
            <Row>
              <Col xs={12} className="pr-0">
                <p className={`mb-1`}>
                  <span className={`${styles.BoldU}`}>Pro Cord:</span>
                </p>
              </Col>
              <Col xs={12} className="pr-0">
                <p className={`${styles.WhiteAqua} mb-1`}>
                  {pro_coordinator_name} - {pro_coordinator_phone}
                </p>
              </Col>
            </Row>
            {/* Director */}
            <Row>
              <Col xs={12} className="pr-0">
                <p className={`mb-1`}>
                  <span className={`${styles.BoldU}`}>Director:</span>
                </p>
              </Col>
              <Col xs={12} className="pr-0">
                <p className={`${styles.WhiteAqua} mb-1`}>
                  {director_name} - {director_phone}{" "}
                </p>
              </Col>
            </Row>
          </Col>
          <Col md={4} className="text-center pb-0">
            <div>
              <Col
                className={`mb-1 text-center `}
              >
                <span className={` ${styles.MovieName}`}>{production_name}</span>
              </Col>
            </div>
            {/* logo */}
            <div className={`mt-0`}>
              {company_logo ? (
                <>
                  <div className="px-3">
                    <Image
                      className={styles.Logo}
                      src={company_logo}
                      alt="logo image"
                    />
                  </div>
                </>
              ) :
                <>
                  <div className="px-3">
                    <Image
                      className={styles.Logo}
                      src={sceneblue2}
                      alt="logo image"
                    />
                  </div>
                </>
              }
            </div>
            <div className="mt-2 mb-0 pb-0 mx-md-4">
              <p className={`${styles.UnitCallMedDate}`}>
                Day {day}
              </p>
              <p className={`px-0 ${styles.UnitCallMedDate}`}>{date} </p>
            </div>
            {/* your call */}
            <div className={`mt-2`}>
              <Row>
                <Col md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}
                  className="px-0">
                  <div className={`${styles.CountryBack}`}>
                    {yourcalltime && (
                      <>
                        <h3 className={` mb-0 pb-0 ${styles.YourCallMedv}`}>Your Call</h3>
                        <h3 className={` pb-0 ${styles.YourCallMedv}`}>
                          {yourcalltime}{" "}
                        </h3>
                      </>
                    )}
                    {yourCastcalltime && (
                      <>
                        <h3 className={` mb-0 pb-0 ${styles.YourCallMedv}`}>Your Call</h3>
                        <h3 className={`px-1 my-0 pb-0 ${styles.YourCallMedv}`}>
                          {yourCastcalltime}{" "}
                        </h3>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
            {/* unit */}
            {yourcalltime || yourCastcalltime ? (
              <div className={`mt-2 mx-3 pb-0 ${styles.Border2}`}>
                <h2 className={`px-1 my-0 pb-0 ${styles.UnitCallMed}`}>Unit Call</h2>
                <h2 className={`${styles.UnitCallMed}`}>{unit_call} </h2>
              </div>
            ) : (
              <div className={`my-4`}>
                <Row>
                  <Col md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}
                    className="px-0">
                    <div className={`${styles.CountryBack} py-1`}>
                      <h3 className={` mb-0 pb-0`}>Unit Call</h3>
                      <h3 className={` pb-0 mb-0`}>
                        {unit_call}{" "}
                      </h3>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            <div>
              <p className={`mt-1 ${styles.Bold}`} >Weather </p>
              <p className={`${styles.WhiteAqua} mb-1`} >{location_2_name} </p>
            </div>
          </Col>
          <Col className="pl-5 mt-5" md={4}>
            <Row>
              <Col xs={2} ></Col>
              <Col xs={10}>
                {/* weather */}
                <Row>
                  <Col xs={7} className='px-0'>
                    <p className={`mb-1 ${styles.BoldV}`} >Sunrise:</p>
                    <p className={`mb-1 ${styles.Bold}`} >Sunset:</p>
                  </Col>
                  <Col xs={5} className='px-0'>
                    <p style={{ textTransform: 'uppercase' }} className={`${styles.WhiteAqua} mb-1`} >{location_3_name}</p>
                    <p style={{ textTransform: 'uppercase' }} className={`${styles.WhiteAqua} mb-1`}>{location_4_name}</p>
                  </Col>
                </Row>
                {/* <Weather 
            temp2={location_2_name}
            rise2={location_3_name}
            sunset2={location_4_name}
            weather_location={weather_location} /> */}
                <Row>
                  <Col xs={7} className='px-0'>
                    <p className={`mb-1`}>
                      <span className={`${styles.BoldV}`}>Talent Call:</span>{" "}
                    </p>
                    <p className={`mb-1`}>
                      <span className={`${styles.Bold}`}>First Shot:</span>
                    </p>
                    <p className={`mb-1`}>
                      <span className={`${styles.Bold}`}>Breakfast:</span>
                    </p>
                    <p className={`mb-1`}>
                      <span className={`${styles.Bold}`}>Lunch:</span>
                    </p>
                    <p className={`mb-1`}>
                      <span className={`${styles.Bold}`}>Est. Wrap:</span>
                    </p>
                  </Col>
                  <Col xs={5} className='px-0'>
                    <p className={`${styles.WhiteAqua} mb-1`}>{talent_call} </p>
                    <p className={`${styles.WhiteAqua} mb-1`}>{shoot_call}</p>
                    <p className={`${styles.WhiteAqua} mb-1`}>{breakfast}</p>
                    <p className={`${styles.WhiteAqua} mb-1`}>{lunch}</p>
                    <p className={`${styles.WhiteAqua} mb-1`}>{wrap}</p>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className='px-0'>
                    <p className={`mb-0 mt-3 ${styles.BoldU}`}>Nearest Hospital:
                    </p>
                    <p className={`mb-1 ${styles.WhiteAqua}`}>
                      {nearest_hospital}{" "}
                    </p>
                    <p className={`mb-1 ${styles.WhiteAqua}`}>
                      {hospital_address_line_1}{" "}
                    </p>
                    <p className={`mb-1 ${styles.WhiteAqua}`}>
                      {hospital_address_line_2}{" "}
                    </p>
                    <p className={`mb-1 ${styles.WhiteAqua}`}>
                      {hospital_address_line_3}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="px-3">
          <Col xs={4}>
            {/* 1st AD */}
            <Row className="mt-2">
              <Col xs={12}>
                <p className={`mb-1`}>
                  <span className={`${styles.BoldU}`}>1st AD:</span>
                </p>
              </Col>
              <Col xs={12}>
                <p className={`${styles.WhiteAqua} mb-1`}>
                  {ad_1_name} - {ad_1_phone}{" "}
                </p>
              </Col>
            </Row>
          </Col>
          <Col xs={4}>
            <div
              className={`mt-0 mx-3 py-0 px-2 text-center ${styles.Border2}`}
            >
              <p className={`mb-0 pt-1`}>
                <span className={`${styles.BoldU}`}>First Location</span>
              </p>
              <h5 className={`mb-1 ${styles.WhiteAqua}`}>{firstLoc} </h5>
            </div>
          </Col>
          <Col xs={4} className="pl-4">
            <Row>
              <Col xs={2}></Col>
              <Col xs={10} >
                <div className="mt-0">
                  <p className={`mb-0 pl-2 mt-2 ${styles.BoldU}`}>Day {day} of {total_shoot_days}{" "}
                  </p>
                </div>
                <div>
                  <p className={`mb-0 pl-2 mt-2 ${styles.WhiteAqua}`}>
                    User: {firstname} {lastname}
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* Locations */}
        <LocationsPage callsheet={callsheet} newLocs={newLocs} />
        {/* Schedule  */}
        <SchedulePage scenes={scenes} />
        {/* Talent  */}
        <TalentPage handleMount={handleMount} cast={cast} />
        {/* BG AND STANDINS */}
        <BgPage background={background} handleMount={handleMount} />
        {/* Crew */}
        <CrewCallsPage callsheet={callsheet} />
        {/* Notes */}
        <NotesPage
          important_info={important_info}
          transport_info={transport_info}
          department_info={department_info}
        />
        {/* Advanced Schedule  */}
        {advancedScheduleDayId ? (
          <AdvancedSchedPage
            callsheet={callsheet}
            advancedDay={advancedScheduleDayId}
          />
        ) : (
          <>
            <h4 className={`mt-5 pl-3 py-0 px-1 ${styles.SubTitleSpan}`}
              style={{ textTransform: 'uppercase' }}>
              Advanced Schedule <span className={`${styles.HSpan}`} >
                Advanced Schedule Day to be selected
              </span>
            </h4>
            <hr className={`mb-0 pl-3 mt-0 pt-1 ${styles.Break5}`} />
          </>
        )}
        {/* Walkie Channels */}
        <WalkiesPage />
      </div>
      {/* MOBILE  */}
      <div className="d-block d-md-none mb-5">
        {location_5_name && (
          <Row>
            <Col
              className={`text-center `}
              xs={{ span: 8, offset: 2 }}
            >
              <div className={`mx-3 pb-0 px-2 ${styles.CountryBack}`}>
                <h4 style={{ textTransform: 'uppercase' }} className={`mb-0 pb-0 ${styles.vv}`}>
                  {location_5_name} SHOOT</h4>
              </div>
            </Col>
          </Row>
        )}
        <div>
          {/* name WhiteAquaProU MovieNameMo*/}
          <Row>
            <Col className="text-center" xs={{ span: 8, offset: 2 }}>
              <p className={`px-2 ${styles.MovieNameMo}`}>{production_name} </p>
            </Col>
          </Row>
          {/* header */}
          <Row className="px-3">
            {/* weather/calls */}
            <Col className={`pl-0 pr-0`} xs={3}>
              {/* weather */}
              {/* <Weather weather_location={weather_location} /> */}
              <div>
                <Row>
                  <Col xs={12}>
                    <p className={`mb-0 ${styles.BoldV}`} >Sunrise:</p>
                    <p style={{ textTransform: 'uppercase' }}
                      className={`${styles.WhiteAqua}`}>{location_3_name} </p>
                    <p className={`mb-0 {styles.Bold}`} >Sunset:</p>
                    <p style={{ textTransform: 'uppercase' }}
                      className={`${styles.WhiteAqua}`}>{location_4_name} </p>
                    <p className={`mb-0 ${styles.Bold}`} >Weather:</p>
                    <p className={`${styles.WhiteAqua}`} >{location_2_name}</p>
                  </Col>
                </Row>
              </div>
            </Col>
            {/* logo calls */}
            <Col xs={6} className="px-0 mx-0 text-center">
              <h5 className={`mb-1 pl-0 ${styles.WhiteAquaProU}`}>
                {production_company}{" "}
              </h5>
              <div className={`mt-0`}>
                {company_logo ? (
                  <>
                    <div className="px-3">
                      <Image
                        className={styles.LogoMo}
                        src={company_logo}
                        alt="logo image"
                      />
                    </div>
                  </>
                ) :
                  <>
                    <div className="px-3">
                      <Image
                        className={styles.LogoMo}
                        src={sceneblue2}
                        alt="logo image"
                      />
                    </div>
                  </>
                }
              </div>
              <div className="mt-1 mb-1 pb-0">
                <Row>
                  <Col>
                    <p className={`mx-3 ${styles.UnitCallMobDate}`}>
                      {date}
                    </p>
                  </Col>
                </Row>
              </div>
              {/* your call */}
              <div className={`mt-2`}>
                <Row>
                  <Col xs={{ span: 8, offset: 2 }}
                    className="px-0">
                    <div className={`${styles.CountryBack} mx-3`}>
                      {yourcalltime && (
                        <>
                          <h5 className={` mb-0 pb-0 ${styles.YourCallMedv}`}>Your Call</h5>
                          <h5 className={` pb-0 ${styles.YourCallMedv}`}>
                            {yourcalltime}{" "}
                          </h5>
                        </>
                      )}
                      {yourCastcalltime && (
                        <>
                          <h3 className={` mb-0 pb-0 ${styles.YourCallMedv}`}>Your Call</h3>
                          <h3 className={`px-1 my-0 pb-0 ${styles.YourCallMedv}`}>
                            {yourCastcalltime}{" "}
                          </h3>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            {/* calls */}
            <Col xs={3} className={`px-0`}>
              <div className={` mt-0`}>
                <p className={`mb-0`}>
                  <span className={`${styles.BoldV}`}>Cast Call:</span>{" "}
                </p>
                <p className={`${styles.WhiteAqua}`}>{talent_call} </p>
                <p className={`mb-0`}>
                  <span className={`${styles.Bold}`}>First Shot:</span>
                </p>
                <p className={`${styles.WhiteAqua}`}>{shoot_call}</p>
                <p className={`mb-0`}>
                  <span className={`${styles.Bold}`}>Est. Wrap:</span>{" "}
                </p>
                <p className={`${styles.WhiteAqua}`}>{wrap}</p>
              </div>
            </Col>
          </Row>
          <Row className="px-3">
            <Col xs={3} className={`px-0`}>
              {/* meals */}
              <div className={``}>
                <p className={`mb-0`}>
                  <span className={`${styles.BoldU}`}>Breakfast:</span>
                </p>
                <p className={`${styles.WhiteAqua} mb-0`}>{breakfast}</p>
                <p className={` mb-0`}>
                  <span className={`${styles.Bold}`}>Lunch:</span>{" "}
                </p>
                <p className={`${styles.WhiteAqua} mb-0`}>{lunch} </p>
              </div>
            </Col>
            <Col xs={6} className="text-center" >
              <div className={`mt-1 mx-3 pb-0 px-sm-2 ${styles.Border2}`}>
                <h5 className={`px-1 pb-0 mb-0 ${styles.UnitCallMob}`}>Unit Call</h5>
                <h5 className={`px-1 pb-0 mb-0 ${styles.UnitCallMob}`}>
                  {unit_call}{" "}
                </h5>
              </div>
              {/* loc */}
              <div className={`mt-0 mx-0 pb-0 px-0`}>
                <Row>
                  <Col xs={12}>
                    <p className={`mb-0 pt-0 text-center ${styles.Bold}`}>
                      1st Location
                    </p>
                    <p className={`mb-1 ${styles.WhiteAqua}`}>
                      {firstLoc}{" "}
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={3} className={`px-0`}>
              <div >
                <p className={`mb-0`}>
                  <span className={`${styles.BoldU}`}>Day:</span>{" "}
                </p>
                {total_shoot_days ? (
                  <p className={`${styles.WhiteAqua}`}>
                    {`Day ${day} of ${total_shoot_days}`}
                  </p>
                ) : (
                  <p className={`${styles.WhiteAqua}`}>
                    {`Day ${day}`}
                  </p>
                )}
              </div>
              <p className={`${styles.Bold} mb-0`}>User:</p>
              <p className={`${styles.WhiteAqua}`}> {firstname} {lastname}</p>
            </Col>
          </Row>
        </div>
        <hr className={`mt-3 mb-0 ${styles.Break5}`} />
        {/* <p className={`mt-2 pl-3 mb-0 pt-1 ${styles.Break5}`}></p> */}
        {/* buttons */}
        <Row>
          <Col xs={{ span: 8, offset: 2 }} className="text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowHos((showHos) => !showHos)}
            >
              Nearest Hospital
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={4} className="text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowContacts((showContacts) => !showContacts)}
            >
              Contacts
            </p>
          </Col>
          <Col xs={4} className="text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowLoc((showLoc) => !showLoc)}
            >
              Locations
            </p>
          </Col>
          <Col xs={4} className="text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowWalkies((showWalkies) => !showWalkies)}
            >
              Walkies
            </p>
          </Col>
        </Row>
        <Row className={`${styles.ButtonLine} mt-0`}>
          <Col xs={4} md={2} className="text-center">
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowSched((showSched) => !showSched)}
            >
              {" "}
              Schedule
            </p>
          </Col>
          <Col xs={4} md={2} className="text-center">
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowTalent((showTalent) => !showTalent)}
            >
              {" "}
              Talent
            </p>
          </Col>
          <Col xs={4} className="mx-0 text-center py-0" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowBg((showBg) => !showBg)}
            >
              {" "}
              Background
            </p>
          </Col>
          <Col xs={4} className="text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowNotes((showNotes) => !showNotes)}
            >
              Notes
            </p>
          </Col>
          <Col xs={4} className="mx-0 px-0 text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() => setShowCrew((showCrew) => !showCrew)}
            >
              {" "}
              Crew
            </p>
          </Col>
          <Col xs={4} className="mx-0 px-0 text-center" md={2}>
            <p
              className={`py-0 mb-0 ${styles.Button}`}
              onClick={() =>
                setShowAdvanSched((showAdvanSched) => !showAdvanSched)
              }
            >
              {" "}
              Adv Schedule
            </p>
          </Col>
        </Row>
        <hr className={`mt-3 mb-0 ${styles.Break5}`} />
        {/* pages */}
        {!showHos ? (
          ""
        ) : (
          <HospitalPage
            callsheet={callsheet}
            crewInfoOne={crewInfoOne}
            setShow={setShowHos}
          />
        )}
        {!showContacts ? (
          ""
        ) : (
          <ContactsPage
            callsheet={callsheet}
            crewInfoOne={crewInfoOne}
            setShow={setShowContacts}
          />
        )}
        {!showLoc ? (
          ""
        ) : (
          <LocationsPage
            callsheet={callsheet} newLocs={newLocs} setShow={setShowLoc} />
        )}
        {!showWalkies ? (
          ""
        ) : (
          <WalkiesPage setShow={setShowWalkies} />
        )}
        {!showSched ? (
          ""
        ) : (
          <SchedulePage
            scenes={scenes}
            callsheet={callsheet}
            setShow={setShowSched}
          />
        )}
        {!showTalent ? (
          ""
        ) : (
          <TalentPage
            handleMount={handleMount}
            cast={cast}
            callsheet={callsheet}
            setShow={setShowTalent}
          />
        )}
        {!showBg ? (
          ""
        ) : (
          <BgPage
            handleMount={handleMount}
            background={background}
            callsheet={callsheet}
            setShow={setShowBg}
          />
        )}
        {!showNotes ? (
          ""
        ) : (
          <NotesPage
            important_info={important_info}
            transport_info={transport_info}
            department_info={department_info}
            setShow={setShowNotes}
          />
        )}
        {!showCrew ? (
          ""
        ) : (
          <CrewCallsPage callsheet={callsheet} setShow={setShowCrew} />
        )}
        {!showAdvanSched ? (
          ""
        ) : (
          <>
            {advancedScheduleDayId ? (
              <AdvancedSchedPage
                advancedDay={advancedScheduleDayId}
                callsheet={callsheet}
                setShow={setShowAdvanSched}
              />
            ) : (
              <p>Advanced Schedule Day to be selected</p>
            )}
          </>

        )}
      </div>
    </div>
  );
};

export default CallSheet;
